<script context="module" lang="ts">
	export function totalPages(
		totalPage: number,
		presentPage: number,
		divide: number
	) {
		//

		const firstPage = presentPage - (presentPage % divide);
		const lastPage =
			firstPage + divide < totalPage ? firstPage + divide : totalPage;
		const arrayLenth = lastPage - firstPage < 0 ? 0 : lastPage - firstPage;
		const pages = new Array(arrayLenth).fill(null).map((_, i) => i + firstPage);

		const hasAfterPage = firstPage + divide < totalPage;
		const isFirstSection = firstPage > 0;
		return {
			isFirstSection,
			hasAfterPage,
			pages,
		};
	}

</script>

<script lang="ts">
	import LeftRight from "../SVG/LeftRight.svelte";

	export let totalPage = 0;
	export let presentPage = 0;
	export let buttonCallback = (page: number) => {};
	export let { mobile, desktop } = {
		mobile: 4,
		desktop: 10,
	};

	type pageRef = {
		isFirstSection: boolean;
		hasAfterPage: boolean;
		pages: number[];
	};

	function quickButtonHandler(ref: pageRef, divide: number, rl: "l" | "r") {
		if (rl === "l") {
			const next = (ref.pages[0] || 0) - divide;
			const isUnder = next <= 0;
			buttonCallback(isUnder ? 0 : next);
		} else {
			const next = (ref.pages[0] || 0) + divide;
			const isOver = next >= totalPage;
			const overPage = totalPage === 0 ? 0 : totalPage - 1;
			buttonCallback(isOver ? overPage : next);
		}
	}

	$: mobilePages = totalPages(totalPage, presentPage, mobile);
	$: desktopPages = totalPages(totalPage, presentPage, desktop);

</script>

<div class="mobile container">
	<button
		class="quick-button l"
		on:click={() => quickButtonHandler(mobilePages, mobile, 'l')}>
		<LeftRight direction={'left'} />
	</button>
	<div class="button-wrapper">
		{#if mobilePages.isFirstSection}
			<button on:click={() => buttonCallback(0)}>1...</button>
		{/if}
		{#each mobilePages.pages as page}
			<button
				class:present={presentPage === page}
				on:click={() => buttonCallback(page)}>{page + 1}</button>
		{/each}
		{#if mobilePages.hasAfterPage}
			<span>…</span>
			<button
				on:click={() => buttonCallback(totalPage - 1)}>{totalPage}</button>
		{/if}
	</div>
	<button
		class="quick-button r"
		on:click={() => quickButtonHandler(mobilePages, mobile, 'r')}>
		<LeftRight direction={'right'} />
	</button>
</div>
<div class="desktop container">
	<button
		class="quick-button l"
		on:click={() => quickButtonHandler(desktopPages, desktop, 'l')}>
		<LeftRight direction={'left'} />
	</button>
	<div class="button-wrapper">
		{#if desktopPages.isFirstSection}
			<button on:click={() => buttonCallback(0)}>1...</button>
		{/if}
		{#each desktopPages.pages as page}
			<button
				class:present={presentPage === page}
				on:click={() => buttonCallback(page)}>{page + 1}</button>
		{/each}
		{#if desktopPages.hasAfterPage}
			<span>…</span>
			<button
				on:click={() => buttonCallback(totalPage - 1)}>{totalPage}</button>
		{/if}
	</div>
	<button
		class="quick-button r"
		on:click={() => quickButtonHandler(desktopPages, desktop, 'r')}>
		<LeftRight direction={'right'} />
	</button>
</div>

<style lang="scss">
	@import "../variables.scss";

	.desktop {
		display: none;
	}
	.mobile {
		display: flex;
	}

	span {
		display: flex;
		align-items: center;
	}
	.button-wrapper {
		display: flex;
		box-sizing: border-box;
		align-items: center;
		max-width: calc(100% - 60px - 25px);
		overflow-y: hidden;
		overflow-x: auto;

		&::-webkit-scrollbar {
			height: 2px;
		}
		&::-webkit-scrollbar-thumb {
			background: linear-gradient(
				to bottom right,
				var(--signature-blue),
				silver
			);
		}
	}

	button {
		margin: 0;
		padding: 0;
		background-color: transparent;
		outline: none;
		border: none;
		color: #6d6f76;
		transition: 0.5s color;
		padding: 0px 5px;
		font-weight: 200;
		&.quick-button {
			width: 10px;
			height: 19.8px;
			padding: 0;

			&.r {
				margin-left: 30px;
			}

			&.l {
				margin-right: 30px;
			}
		}

		&:hover {
			cursor: pointer;
			color: var(--default-hover-btn-1);
		}

		&.present {
			color: #3c68d6;
			font-weight: 500;
			text-decoration: underline;
		}
	}
	.container {
		width: 100%;
		justify-content: center;
	}

	@include DesktopSize {
		.desktop {
			display: flex;
			align-items: center;
		}
		.mobile {
			display: none;
		}

		button {
			font-size: 1.25rem;
			padding: 0px 9px;
		}
	}

</style>
